import EmberService from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { UserManagementDialogsObject } from '@databox/ember-integrations/lib/components/UserManagement/UserManagementDialogs';

export default class UserManagementService extends EmberService {
	@tracked userManagementFunctions?: UserManagementDialogsObject = undefined;

	get functions(): UserManagementDialogsObject | undefined {
		return this.userManagementFunctions;
	}
}

declare module '@ember/service' {
	interface Registry {
		'user-management': UserManagementService;
	}
}
